import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { Input } from '@angular/core';
import { ViewChild } from '@angular/core';
import { IonNav } from '@ionic/angular';

import { platformService } from '@unpispas/upp-base';
import { viewService } from '@unpispas/upp-base';

@Component({
    selector: 'upp-application',
    templateUrl: './upp-application.html',
    styleUrls: ['./upp-application.scss'],
})
export class UppApplicationComponent implements AfterViewInit, OnDestroy {
    @Input() menu: 'show' | 'hide' = 'hide';

    @ViewChild('ionnav', {static: false}) _ionnav: IonNav | null = null;
    private _ionnav_observer: MutationObserver | null = null;

    get HasMenu(){
        return this.menu == 'show';
    }

    get Ready(){
        return this.platform.IsReady;
    }

    constructor(private platform: platformService, public view: viewService){
        // nothing to do
    }

    ngAfterViewInit(): void {
        this.platform.ready().then(
        () => {
            this.platform._theme = this.view.Theme || 'light';
        });

        // avoid accesibility error for ionic element
        if (this._ionnav) {
            setTimeout(() => {
                const _element = (this._ionnav as any)?.el as HTMLElement;
                if (_element){
                    this._ionnav_observer = new MutationObserver(() => {
                        if (_element.getAttribute('aria-hidden') === 'true') {
                            (document.activeElement as HTMLElement)?.blur();
                        }
                    });    

                    this._ionnav_observer.observe(_element, { attributes: true, attributeFilter: ['aria-hidden'] });    
                }
            }, 100);
        }
    }

    ngOnDestroy(): void {
        if (this._ionnav_observer){
            this._ionnav_observer.disconnect();
            this._ionnav_observer = null;
        }
    }
}
